"use strict";

exports.__esModule = true;
exports.default = void 0;

var _fns = require("@react-pdf/fns");

/**
 * Checks if page has auto height
 *
 * @param {Object} page
 * @returns {Boolean} is page height auto
 */
var isHeightAuto = function isHeightAuto(page) {
  var _page$box;

  return (0, _fns.isNil)((_page$box = page.box) === null || _page$box === void 0 ? void 0 : _page$box.height);
};

var _default = isHeightAuto;
exports.default = _default;